import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VCard,{staticClass:"elevation-6"},[_c(VCardTitle,{directives:[{name:"t",rawName:"v-t",value:(_vm.title),expression:"title"}],staticClass:"title"}),_c(VCardSubtitle,{directives:[{name:"t",rawName:"v-t",value:(_vm.subtitle),expression:"subtitle"}]}),_c(VCardText,[_vm._t("list")],2)],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }